console.log('js/dialogs_conditions.js -> v0.1.0');
$(function() {

	$('#payment_percentage').on('input', function() {
		if (parseInt($(this).val() / 100) > $(this).attr('min') / 100)
			$(this).val(parseInt($(this).val() / 100) * 100);
		$($(this).data('target2')).text($(this).val() / 100 + '%');
	});

	 $('#x_days_before').on('input click', function() {
		$('input[name=rest_paid_on][value=before_arrival]').click();
		$(this).focus();
	 });

	 $('#refundable_nr_days_before_checkin').on('input click', function() {
		$('input[name=cancellation_policy][value=refundable]').click();
		$(this).focus();
	 });

	$('#payment_percentage').on('input click', function() {
		$('input[name=deposit_type][value=percentage]').click();
		$('input[name=deposit_type]').each(function (i, e) {
			$(e).parent().css({ opacity: $(e).prop('checked') ? 1 : 0.7 });
		})
	});

	$('input[name=deposit_type]').on('change', function(e) {
		$('input[name=deposit_type]').each(function (i, e) {
			$(e).parent().css({ opacity: $(e).prop('checked') ? 1 : 0.5 });
		})
	});

	// same as toggle switch but with better selectors - the other one can be deleted as the new dialog page is full on

	var paymentSwitch = $('.js-payment-switch-label');
	var acceptPaymentToggle = function(){

		var paymentCheckbox = paymentSwitch.find('input');
		var paymentSlider = paymentSwitch.find('.js-payment-slider');

		var enablePaymentOptionsInfo = $('.js-enabled-payment-settings-info');
		var dsiablePaymentOptionsInfo = $('.js-disabled-payment-settings-info');

		var text0 = (paymentCheckbox.data('text-0') ? paymentCheckbox.data('text-0') : "Disabled");
		var text1 = (paymentCheckbox.data('text-1') ? paymentCheckbox.data('text-1') : "Enabled");

		// deals with the status of the slider and hides and shows the rest of the elements
		if (paymentCheckbox.is(":checked")) {
			// online payments enabled
			paymentSlider.text(text1);
			enablePaymentOptionsInfo.each(function(){
				$(this).removeClass('hide');
			});
			dsiablePaymentOptionsInfo.each(function(){
				$(this).addClass('hide');
			});
		} else {
			// online payments disabled
			paymentSlider.text(text0);
			enablePaymentOptionsInfo.each(function(){
				$(this).addClass('hide');
			});
			dsiablePaymentOptionsInfo.each(function(){
				$(this).removeClass('hide');
			});
		}

	};

	// init default state onto slider
	acceptPaymentToggle();

	// when switch is clicked change status again
	paymentSwitch.change(function(){
		acceptPaymentToggle();
		gae('dialogsPage', 'disable_payment_toggle');
	});
});
